import { BASE_API } from '../constants/sharedConfig';
import queryUtils from './queryUtils';

type ExportExcelArgs = {
  baseUrl: string;
  excelPath: string;
  startDateYyyyMmDd: string;
  endDateYyyyMmDd?: string;
  limit?: number;
  listingAlias?: string;
};

const EXCEL_LIMIT = 15000;

export default ({
  baseUrl,
  excelPath,
  startDateYyyyMmDd,
  endDateYyyyMmDd,
  limit = EXCEL_LIMIT,
  listingAlias,
}: ExportExcelArgs) => {
  const excelParams = {
    limit,
    startDateYyyyMmDd,
    ...(listingAlias && { listingId: listingAlias }),
    ...(endDateYyyyMmDd && { endDateYyyyMmDd }),
  };

  return `${baseUrl}/proxy/${BASE_API}${excelPath}${queryUtils.stringify(excelParams)}`;
};
